// Browser Web Push is off: notifications come only from the mobile shells (messagePush.js)
// import { pushSubscriptionManager } from './pushSubscriptionManager.js';
import { initMessagePush } from './messagePush.js';
import { GUDHUB_SETTINGS } from '../../gudhub_settings.js';

export function initPushNotifications(conversationsElement) {
    if (!GUDHUB_SETTINGS.show_conversations) return;

    listenForNotificationClicks(conversationsElement);

    // Inside the mobile shells notifications are native (messagePush.js): a
    // WebView has no Web Push, and a browser subscription there could only
    // ever duplicate them.
    if (initMessagePush(conversationsElement)) return;

    // Browser Web Push is off
    // const activeUserId = conversationsElement.activeUserId;

    // pushSubscriptionManager.init(activeUserId).then((status) => {
    //     if (status === 'should_prompt') {
    //         setTimeout(() => showPushPermissionDialog(conversationsElement), 3000);
    //     }
    // }).catch((err) => {
    //     console.warn('Push notification init failed', err);
    // });
}

// Browser Web Push is off: the permission dialog is never shown
// function showPushPermissionDialog(conversationsElement) {
//     if (document.querySelector('.push_notification_dialog')) return;

//     const ghDialog = gudhub.ghconstructor.angularInjector.get('GhDialog');

//     ghDialog.show({
//         position: 'center',
//         class: 'push_notification_dialog',
//         toolbar: false,
//         clickOutsideToClose: true,
//         closeCallBack: function() {},
//         template: {
//             toolbar: '',
//             content: `
//                 <div class="push_notification_prompt" style="padding: 24px; text-align: center; max-width: 320px; position: relative;">
//                     <div ng-click="dismiss()" style="position: absolute; top: 8px; right: 8px; cursor: pointer; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; opacity: 0.5;" onmouseenter="this.style.opacity='1'" onmouseleave="this.style.opacity='0.5'">
//                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#333">
//                             <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
//                         </svg>
//                     </div>
//                     <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="#4A90D9">
//                         <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
//                     </svg>
//                     <h3 style="margin: 12px 0 8px;">Enable Notifications</h3>
//                     <p style="margin: 0 0 20px; color: #666; font-size: 14px;">Get notified when you receive new messages, even when the app is in the background.</p>
//                     <div style="display: flex; gap: 8px; justify-content: center;">
//                         <button class="gh-btn inline" ng-click="dismiss()" style="border: 1px solid #ccc; font-weight: 500;">Not now</button>
//                         <button class="gh-btn inline gh-btn-blue gh-btn-bg" ng-click="enable()" style="font-weight: 500;">Enable</button>
//                     </div>
//                 </div>
//             `
//         },
//         controller: ['$scope', function($scope) {

//             $scope.enable = async function() {
//                 $scope.hide();
//                 await pushSubscriptionManager.requestAndSubscribe(conversationsElement.activeUserId);
//             };


//             $scope.dismiss = function() {
//                 $scope.hide();
//             };
//         }]
//     });
// }

function listenForNotificationClicks(conversationsElement) {
    window.addEventListener('gh_push_notification_click', async (event) => {
        const { conversation_id } = event.detail;
        if (!conversation_id) return;

        conversationsElement.setExpanded(true);

        try {
            const response = await fetch(
                `${GUDHUB_SETTINGS.conversation_server_url}/gudhub-messenger/${conversation_id}?user_id=${conversationsElement.activeUserId}`
            );
            const conversation = await response.json();

            if (conversation.type === 'direct') {
                const otherUserId = conversation.participants
                    .map(String)
                    .find(id => id !== String(conversationsElement.activeUserId));

                if (otherUserId) {
                    conversationsElement.dispatchEvent(new CustomEvent('switch_chat_view', {
                        bubbles: false,
                        detail: { view: 'direct_message', user_id: otherUserId }
                    }));
                }
            } else if (conversation.type === 'channel') {
                conversationsElement.dispatchEvent(new CustomEvent('switch_chat_view', {
                    bubbles: false,
                    detail: {
                        view: 'channel',
                        conversation_id: conversation.conversation_id,
                        name: conversation.name
                    }
                }));
            } else if (conversation.type === 'item' && conversation.item_ref) {
                conversationsElement.dispatchEvent(new CustomEvent('switch_chat_view', {
                    bubbles: false,
                    detail: {
                        view: 'item_discussion',
                        conversation_id: conversation.conversation_id,
                        item_ref: conversation.item_ref
                    }
                }));
            }
        } catch (err) {
            console.error('Failed to open conversation from push notification', err);
        }
    });
}
